import type { CompanyStore } from "services/company/companyStore";
import { GstTurnoverOptions } from "services/company/companyTypes";
import type { IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { AbnQuestion } from "./abnConstants";

export class AbnQuestionsStore extends QuestionsStore<AbnQuestion> {
  constructor(
    private readonly _companyStore: CompanyStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(AbnQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): AbnQuestion | undefined {
    // Return undefined to show all questions in sequence
    // Question skipping is handled by _shouldSkipQuestion() method
    return undefined;
  }

  protected _shouldSkipQuestion(question: AbnQuestion): boolean {
    const { company } = this._companyStore;
    const isGSTRequested = company?.gstRegistrationRequested ?? false;

    // Define all GST-related questions that should be skipped when GST is not requested
    const gstDependentQuestions = [
      AbnQuestion.GSTTurnover,
      AbnQuestion.GSTLodgementFrequency,
      AbnQuestion.GSTCashAccounting,
      AbnQuestion.GSTImportsGoods,
    ];

    // Skip GST-related questions if gstRegistrationRequested is false
    if (gstDependentQuestions.includes(question) && !isGSTRequested) {
      return true;
    }

    // Skip GSTLodgementFrequency if turnover is $20M+
    if (question === AbnQuestion.GSTLodgementFrequency) {
      const gstTurnover = company?.gstTurnover;
      if (gstTurnover === GstTurnoverOptions.OVER_20_MILLION) {
        return true;
      }
    }

    return super._shouldSkipQuestion(question);
  }
}
